import React from "react";

import ChartResolver from "../../../../components/charts/ChartResolver";
import { useStyles } from "../items/HomeCardStyles";

export default function ChartKpi(props) {
  const classes = useStyles();

  return (
    <div className={classes.chartContainer}>
      <ChartResolver type={props?.data?.tipo_grafico} {...props} />
    </div>
  );
}
